import { pub } from '../utils/common'
import { memo } from 'react'
import { useNavigate } from 'react-router-dom'

const LogoHead = memo(() => {
  const navigate = useNavigate()
  return <div className="flex mb-1.5" onClick={e => navigate('/')}>
    <div className="cursor-pointer flex">
    <img className="w-[50px] h-[50px] bg-white rounded-[10px]"
         alt="logo"
         src={pub`/assets/images/footer/logo.png`}/>
    <h2 className="mt-[8px] ml-[8px] font-bold text-2xl">CoChiper</h2>
    </div>
  </div>
})

export default LogoHead